export class LdwTabs extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('[href^="#ldw-tabs-"]').forEach(item => {
      item.onclick = function (event) {
        this.parentNode.parentNode.querySelector('.active').classList.remove("active")
        this.parentNode.parentNode.parentNode.querySelector('div').querySelector('.active').classList.remove("active")
        if (event.target.getAttribute('href') === null) {
          event.target.closest('a').parentNode.classList.add("active")
          this.parentNode.parentNode.parentNode.querySelector(event.target.closest('a').getAttribute('href')).classList.add("active")
        } else {
          event.target.parentNode.classList.add("active")
          this.parentNode.parentNode.parentNode.querySelector(event.target.getAttribute('href')).classList.add("active")
        }
        return false;
      }
    });
  }
}
window.customElements.define('ldw-tabs', LdwTabs);
